import { cn } from '../../../lib';

export interface IDirhamSymbolSvgProps {
  className?: string;
}

/**
 * -----------------------------------------------------------------------------
 * This displays the United Arab Emirates Dirham currency symbol
 *
 * Source: https://www.centralbank.ae/media/e4ebcgtb/the_guidelines_for_the_national_currency_symbol_uae_dirham_english.pdf?ref=blog.tap.company
 * Read more: https://www.centralbank.ae/media/ckkp3s3f/cbuae-unveils-new-dirham-symbol-en.pdf
 */
export function DirhamSymbolSvg({ className }: IDirhamSymbolSvgProps) {
  return (
    <svg
      className={cn('size-3', className)}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m23.8 11.4.2.2v-.5c0-1.2-.8-2.1-1.8-2.1h-1.6c-1.1-4.7-5-7.3-10.8-7.3H2.1s1 .9 1 3.6V9H1.2c-.4 0-.7-.1-1-.4L0 8.4v.5C0 10.1.8 11 1.8 11h1.3v2.1H1.2c-.4 0-.7-.1-1-.4l-.2-.2v.5c0 1.2.8 2.1 1.8 2.1h1.3v3.8c0 2.7-1 3.5-1 3.5h7.6c6 0 9.7-2.6 10.8-7.3h2.3c.4 0 .7.1 1 .4l.2.2v-.5c0-1.2-.8-2.1-1.8-2.1h-1.3v-2h2c.4 0 .7.1 1 .4ZM6.3 2.6h3.2c4.3 0 6.8 1.9 7.5 6.3H6.3V2.6Zm3.2 18.8H6.3v-6.3H17c-.7 3.9-2.9 6.1-7.5 6.3Zm7.7-9.4v1H6.3v-2.1h10.9v1Z" />
    </svg>
  );
}
